import api from '@/api/axiosApi'
import type { ExportRead } from '@/types'
import type { CreateExportResponse } from '@/hooks/useExport'

export interface CommitmentLetterGenerateRequest {
  line_item_ids: string[]
  due_date: string
}

export interface CommitmentLetterPreviewResponse {
  content: string
}

/**
 * Preview commitment letter (filled markdown for rendering)
 * POST /plans/{planId}/versions/{versionId}/lines/commitment-letters/preview
 */
export async function previewCommitmentLetter(
  planId: string,
  versionId: string,
  dueDate: string
): Promise<CommitmentLetterPreviewResponse> {
  const response = await api.post<CommitmentLetterPreviewResponse>(
    `/plans/${planId}/versions/${versionId}/lines/commitment-letters/preview`,
    { due_date: dueDate }
  )
  return response.data
}

/**
 * Generate commitment letter export (DOCX + XLSX zipped)
 * POST /plans/{planId}/versions/{versionId}/lines/commitment-letters
 */
export async function createCommitmentLetter(
  planId: string,
  versionId: string,
  request: CommitmentLetterGenerateRequest
): Promise<CreateExportResponse> {
  const response = await api.post<CreateExportResponse>(
    `/plans/${planId}/versions/${versionId}/lines/commitment-letters`,
    request
  )
  return response.data
}

/**
 * Get commitment letter export status and download URL
 * GET /exports/{exportId}
 */
export async function getCommitmentLetterExport(
  exportId: string
): Promise<ExportRead> {
  const response = await api.get<ExportRead>(`/exports/${exportId}`)
  return response.data
}
